import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getCompanies () {
   return Api().get("/companies");
},
  updateCompany (params) {
    return Api().put("/companies",params);
  },
  addCompany (params) {
    return Api().post("/companies",params);
  },
  getCompany (params) {
    return Api().get("/companies/"+params);
  },
  deleteCompany (params) {
    return Api().delete("/companies/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/CompanyService.js